/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Contactlastname_Placeholder2Inputs */

const en_company_registration_contactlastname_placeholder2 = /** @type {(inputs: Company_Registration_Contactlastname_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

const de_company_registration_contactlastname_placeholder2 = /** @type {(inputs: Company_Registration_Contactlastname_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Company_Registration_Contactlastname_Placeholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_contactlastname_placeholder2 = /** @type {((inputs?: Company_Registration_Contactlastname_Placeholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Contactlastname_Placeholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_contactlastname_placeholder2(inputs)
	return en_company_registration_contactlastname_placeholder2(inputs)
});
export { company_registration_contactlastname_placeholder2 as "company_registration_contactLastName_placeholder" }